'use client'

import { ReactNode, useMemo } from 'react'

import { BrazeInboxMessage, useBrazeInboxMessageCards } from '@marketplace-web/braze/braze-feature'

import { invariant, errors } from '../../utils'
import MessageTime from '../MessageTime'
import ConversationHeader from '../ConversationHeader'

type Props = {
  conversationId: string
  leftHeaderAction: ReactNode
}

const BrazeConversation = ({ conversationId, leftHeaderAction }: Props) => {
  const { inboxMessageCards } = useBrazeInboxMessageCards()

  invariant(inboxMessageCards, new errors.InboxMessageCardsNotLoadedError())

  const brazeConversationCard = useMemo(
    () => inboxMessageCards.find(card => card.id === conversationId),
    [conversationId, inboxMessageCards],
  )

  invariant(brazeConversationCard, new errors.InboxMessageCardNotFound({ cardId: conversationId }))

  return (
    <div className="thread__wrapper">
      <div className="thread__messages-container">
        <ConversationHeader left={leftHeaderAction} />
        <div className="thread__messages-wrapper">
          <div className="thread__messages-main">
            <div className="thread__content" data-testid="conversation-content">
              <div className="u-ui-margin-top-large">
                <BrazeInboxMessage
                  card={brazeConversationCard}
                  prefix={<MessageTime card={brazeConversationCard} />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrazeConversation
